import storageApi from "@/api/modules/storage";
import UUID from "@/utils/uuid";
import { MessageBox } from "element-ui";

const STORAGE_BUCKET = "vybbasevrv2";

function putUpload(file, putUrl, callbacks = {}) {
  const xhr = new XMLHttpRequest();

  xhr.upload.addEventListener("progress", event => {
    if (event.lengthComputable && typeof callbacks.onProgress === "function") {
      callbacks.onProgress({
        total: { percent: Math.round((event.loaded / event.total) * 100) }
      });
    }
  });

  xhr.addEventListener("load", () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      if (typeof callbacks.onComplete === "function") callbacks.onComplete();
      return;
    }
    if (typeof callbacks.onError === "function") {
      callbacks.onError(new Error(`上传失败，HTTP ${xhr.status}`));
    }
  });

  xhr.addEventListener("error", () => {
    if (typeof callbacks.onError === "function") {
      callbacks.onError(new Error("上传网络错误"));
    }
  });

  xhr.open("PUT", putUrl);
  xhr.setRequestHeader("X-Amz-ACL", "public-read");
  xhr.send(file);
}

async function uploadOne(file, onProgress = () => {}) {
  const key = UUID.generate() + Date.now();
  const response = await storageApi.getUploadFileToken({
    bucket: STORAGE_BUCKET,
    key
  });
  const domain = `${response.data.protocol}://${response.data.domain}/`;

  return new Promise((resolve, reject) => {
    putUpload(file, response.data.token, {
      onProgress,
      onError: reject,
      onComplete() {
        resolve({ key, preview: domain + key, name: file.name });
      }
    });
  });
}

export default {
  async uploadFiles(files, options = {}) {
    const fileList = Array.from(files || []);
    const sizeLimit = options.size || 20;
    const oversized = fileList.find(file => file.size > sizeLimit * 1024 * 1024);

    if (oversized) {
      const message = `【${oversized.name}】文件体积超过限制，上限${sizeLimit}M`;
      MessageBox.alert(message, "提示", { type: "error" });
      throw new Error(message);
    }
    if (!fileList.length) return [];

    const results = await Promise.all(
      fileList.map(async (file, index) => {
        const result = await uploadOne(file, progress => {
          progress.index = file.index;
          if (typeof options.onProgress === "function") options.onProgress(progress);
        });
        result.index = file.index;
        if (typeof options.onSuccess === "function") options.onSuccess(result);
        return { index, result };
      })
    );

    const ordered = results.sort((a, b) => a.index - b.index).map(item => item.result);
    if (typeof options.onComplete === "function") options.onComplete(ordered);
    return ordered;
  },

  async uploadFile(file, { progress = () => {} } = {}) {
    return uploadOne(file, progress);
  },

  async uploadImage(file) {
    return uploadOne(file);
  }
};
